import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EasiHttpParams } from './easi-http-params';

@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
    constructor() {}

    /**
     * Ajoute withCredentails à toutes les requêtes sauf si elles contiennent l'argument noCredentials
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!(request.params instanceof EasiHttpParams) || !request.params.noCredentials) {
            request = request.clone({
                withCredentials: true
            });
        }
        return next.handle(request);
    }
}
